import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceforpuneoutstation() {



  const cardData =
  {
    keyword: 'Corporate cab services for Pune Outstation',
    heading: 'Pune Corporate Cars India Private Limited: Corporate cab services for Pune Outstation',
    headingDescription: ' Pune Corporate Cars India Private Limited provides reliable and premium Corporate Cab Services for Pune Outstation, ensuring businesses enjoy smooth, comfortable, and punctual long-distance travel. Our fleet of well-maintained sedans, SUVs, and executive cars is perfect for corporate trips, client visits, intercity meetings, and business tours outside Pune. With professional chauffeurs trained for safe highway driving, we guarantee a stress-free and efficient outstation travel experience. Whether your organization needs same-day return trips, multi-city travel, or extended outstation rentals, Pune Corporate Cars India Private Limited delivers secure, cost-effective, and executive-level outstation cab services tailored to corporate requirements.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



  "services": [
  {
    "name": "Outstation Corporate Taxi Pune",
    "description": "Outstation Corporate Taxi Pune offers reliable, comfortable, and professional long-distance travel solutions for business clients. Our service is ideal for corporate meetings, factory visits, conferences, and intercity company travel. Vehicles come fully maintained, sanitized, and driven by trained chauffeurs who ensure safe and punctual journeys. With flexible billing, transparent pricing, and premium ride quality, Outstation Corporate Taxi Pune guarantees a smooth and productive travel experience for all outstation corporate needs."
  },
  {
    "name": "Outstation Employee Travel Pune",
    "description": "Outstation Employee Travel Pune provides safe, organized, and punctual travel arrangements for employees traveling between cities for work. Whether it’s training sessions, client meetings, or project assignments, our cars ensure comfortable long-distance commuting. Vehicles include sedans, SUVs, and tempo travellers based on team size. Our experienced drivers ensure smooth routes, safety, and professional service throughout the journey. Outstation Employee Travel Pune helps companies manage employee mobility efficiently and stress-free."
  },
  {
    "name": "Pune Outstation Chauffeur Service",
    "description": "Pune Outstation Chauffeur Service offers luxury and convenience for long-distance corporate travel. Our chauffeurs are specially trained for intercity routes, professional etiquette, and safe driving. Ideal for executives, senior managers, and VIP corporate guests. Vehicles include premium sedans, SUVs, and executive-class cars with spacious interiors and smooth suspension. Pune Outstation Chauffeur Service delivers a high-comfort, stress-free, and punctual outstation travel experience."
  },
  {
    "name": "Corporate Intercity Cab Pune",
    "description": "Corporate Intercity Cab Pune provides dependable and comfortable cab services for business trips across multiple cities. Designed for sales teams, executives, professionals, and corporate travellers, the service includes clean cars, disciplined drivers, and flexible travel plans. Companies can book one-way, round-trip, or multi-day rentals based on their schedules. Corporate Intercity Cab Pune ensures safe, efficient, and high-quality travel for all intercity corporate requirements."
  },
  {
    "name": "Pune Business Trip Cab Hire",
    "description": "Pune Business Trip Cab Hire is perfect for corporate travel outside the city for meetings, events, inspections, and client engagements. We offer premium sedans and SUVs with professional chauffeurs who understand time-sensitive business travel. Vehicles are fully air-conditioned, clean, and well-maintained for long-distance comfort. With reliable pickup, timely drop, and flexible booking, Pune Business Trip Cab Hire ensures smooth travel for all business-related outstation trips."
  },
  {
    "name": "Outstation Fleet Service Pune",
    "description": "Outstation Fleet Service Pune offers large-scale intercity travel solutions for companies requiring frequent outstation movement. We provide sedans, SUVs, and tempo travellers with full fleet management support including driver allocation, maintenance, and replacements. Ideal for IT firms, manufacturing units, and corporate offices with regular outstation travel. Outstation Fleet Service Pune ensures reliability, cost-efficiency, and organized mobility across all travel routes."
  },
  {
    "name": "Pune to Mumbai Corporate Cab",
    "description": "Pune to Mumbai Corporate Cab offers premium and time-efficient travel for business professionals heading to Mumbai for meetings, airport transfers, events, and corporate activities. Vehicles include sedans and SUVs with AC, clean interiors, and professional chauffeurs. We ensure smooth expressway travel, timely arrival, and safe long-distance driving. Pune to Mumbai Corporate Cab is the preferred choice for hassle-free intercity corporate travel."
  },
  {
    "name": "Pune to Nashik Corporate Cab",
    "description": "Pune to Nashik Corporate Cab provides reliable long-distance travel for executives and corporate teams. Whether it’s plant visits, client meetings, or industrial area travel, our vehicles offer comfort and convenience throughout the journey. Chauffeurs are trained for the Pune–Nashik route, ensuring smooth drives and punctual service. Pune to Nashik Corporate Cab is ideal for safe, professional, and comfortable corporate movement."
  },
  {
    "name": "Pune to Kolhapur Corporate Cab",
    "description": "Pune to Kolhapur Corporate Cab offers comfortable and professional travel solutions for companies with business operations in Kolhapur. Our sedans and SUVs are maintained perfectly for long-distance trips. Drivers ensure safe driving, smooth route handling, and timely travel for meetings, site visits, or business tours. With flexible booking and dedicated support, Pune to Kolhapur Corporate Cab delivers dependable corporate mobility."
  },
  {
    "name": "Pune to Aurangabad Corporate Cab",
    "description": "Pune to Aurangabad Corporate Cab provides efficient and premium intercity travel for companies sending executives or teams to Aurangabad for business. Vehicles come with excellent amenities, clean interiors, and trained drivers. Ideal for manufacturing visits, corporate meetings, and industrial travel. Pune to Aurangabad Corporate Cab ensures a comfortable, safe, and productive travel experience."
  },
  {
    "name": "Corporate Outstation Sedan Pune",
    "description": "Corporate Outstation Sedan Pune offers stylish and comfortable sedans perfect for executive long-distance travel. Vehicles like Dzire, Etios, and Honda City ensure smooth rides, superior seating comfort, and a premium travel environment. Ideal for corporate meetings, client visits, and official intercity trips. Chauffeurs provide professional, safe, and punctual service. Corporate Outstation Sedan Pune is the perfect choice for business travellers seeking comfort and class."
  },
  {
    "name": "Corporate Outstation SUV Pune",
    "description": "Corporate Outstation SUV Pune provides spacious and high-comfort SUVs such as Ertiga, Innova, and Crysta for long-distance company travel. SUVs offer strong suspension, extra luggage space, and superior comfort ideal for group or executive travel. Chauffeurs experienced in intercity routes ensure a safe and smooth journey. Corporate Outstation SUV Pune is ideal for business tours, site visits, and corporate outstation requirements."
  },
  {
    "name": "Corporate Outstation Tempo Traveller Pune",
    "description": "Corporate Outstation Tempo Traveller Pune is designed for large teams and corporate groups traveling intercity for meetings, conferences, or business tours. Tempo Travellers come in 12, 17, and 20-seater options with push-back seats, strong AC, and comfortable interiors. Our drivers ensure safe long-distance travel and punctual service. Corporate Outstation Tempo Traveller Pune ensures organized, economical, and comfortable group travel for corporate needs."
  },
  {
    "name": "Executive Outstation Cab Pune",
    "description": "Executive Outstation Cab Pune offers premium vehicles for high-level executives, VIP clients, and corporate leaders. Cars are equipped with plush interiors, AC, silent cabins, and superior ride quality. Chauffeurs are trained in corporate etiquette, confidentiality, and professional driving. Ideal for important business trips, client interactions, and leadership travel. Executive Outstation Cab Pune ensures luxury, safety, and a smooth intercity travel experience."
  },
  {
    "name": "Best Outstation Cab for Corporate Pune",
    "description": "Best Outstation Cab for Corporate Pune provides top-tier intercity travel services with high-quality vehicles, trained drivers, and exceptional service standards. We offer sedans, SUVs, and tempo travellers to suit different business travel requirements. Every ride is punctual, comfortable, and professionally managed. Ideal for executives, employees, teams, and clients. Best Outstation Cab for Corporate Pune ensures the most dependable and premium outstation corporate travel experience."
  }
],
"tableData": [
  ["Outstation Corporate Taxi Pune", "Outstation Employee Travel Pune"],
  ["Pune Outstation Chauffeur Service", "Corporate Intercity Cab Pune"],
  ["Pune Business Trip Cab Hire", "Outstation Fleet Service Pune"],
  ["Pune to Mumbai Corporate Cab", "Pune to Nashik Corporate Cab"],
  ["Pune to Kolhapur Corporate Cab", "Pune to Aurangabad Corporate Cab"],
  ["Corporate Outstation Sedan Pune", "Corporate Outstation SUV Pune"],
  ["Corporate Outstation Tempo Traveller Pune", "Executive Outstation Cab Pune"],
  ["Best Outstation Cab for Corporate Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services for Pune Outstation",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for Pune outstation travel, ensuring smooth and stress-free long-distance business trips."
  },
  {
    "WhyChooseheading": "Comfortable Long-Distance Travel",
    "WhyChoosedescription": "Our fleet includes spacious and comfortable vehicles designed for long journeys, ensuring a pleasant outstation travel experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained & Sanitized Vehicles",
    "WhyChoosedescription": "All outstation cabs are regularly serviced and sanitized to ensure clean, safe, and hygienic travel for employees and executives."
  },
  {
    "WhyChooseheading": "Transparent Outstation Pricing",
    "WhyChoosedescription": "Enjoy clear and competitive per-kilometer and package-based pricing with no hidden charges, ideal for corporate outstation trips."
  },
  {
    "WhyChooseheading": "Flexible Outstation Packages",
    "WhyChoosedescription": "Choose from one-way, round-trip, and multi-day outstation cab packages tailored to suit corporate travel requirements."
  },
  {
    "WhyChooseheading": "Experienced Outstation Drivers",
    "WhyChoosedescription": "Our trained and experienced chauffeurs are familiar with major outstation routes, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support",
    "WhyChoosedescription": "We offer round-the-clock support for outstation bookings, itinerary adjustments, and travel assistance for corporate clients."
  },
  {
    "WhyChooseheading": "Easy Booking & Quick Confirmation",
    "WhyChoosedescription": "Book your outstation corporate cab easily through our online portal or phone, with fast confirmations and dependable service."
  }
]




















  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate cab services for outstation travel from Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and comfortable corporate cab services for outstation travel from Pune to major cities and business destinations.',
  },
  {
    question: 'How can I book an outstation corporate cab from Pune Corporate Cars India Private Limited?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for outstation corporate cab services?',
    answer: 'We offer a variety of vehicles including sedans, SUVs, luxury cars, and premium vehicles suitable for long-distance corporate travel.',
  },
  {
    question: 'Are drivers experienced in handling outstation corporate routes from Pune?',
    answer: 'Yes, our drivers are highly experienced, professional, and well-versed with major outstation routes to ensure safe and timely travel.',
  },
  {
    question: 'Can I book one-way or round-trip outstation corporate cabs from Pune?',
    answer: 'Absolutely. We offer flexible booking options for both one-way and round-trip outstation corporate cab services.',
  },
  {
    question: 'Are the outstation corporate cab services available 24×7?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides 24×7 availability for all outstation corporate cab requirements.',
  },
  {
    question: 'What safety and hygiene measures are followed for outstation travel?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict safety and hygiene protocols throughout the journey.',
  },
  {
    question: 'What payment options are accepted for outstation corporate cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the outstation corporate cab journey?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you throughout your outstation travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nikhil Phadke',
    feedback: 'We booked an outstation corporate cab for a business trip, and the experience was excellent. Clean car, professional driver, and smooth journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Shinde',
    feedback: 'Pune Corporate Cars India Private Limited provided top-notch service for our Pune to Nashik trip. Highly recommended for corporate outstation travel.',
    rating: 5,
  },
];










































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services for Pune Outstation",
  "image": "https://www.punecorporatecars.com/assets/images/outstation-corporate-cabs-pune.jpg", // replace with actual image URL
  "description": "Professional corporate outstation cab services from Pune to major cities like Mumbai, Nashik, Kolhapur, and Aurangabad. Pune Corporate Cars India Private Limited offers chauffeur-driven sedans, SUVs, and tempo travellers for employee travel, business trips, and executive outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "4900", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500", // starting price per trip, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-outstation-cabs-pune"
  }
};



  return (
    <div>
<Helmet>
  <title>Corporate Cab Services for Pune Outstation | Executive & Business Travel Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Professional corporate outstation cab services from Pune to Mumbai, Nashik, Kolhapur, Aurangabad, and other cities. Chauffeur-driven sedans, SUVs, and tempo travellers for employee travel and business trips with Pune Corporate Cars India Private Limited."
  />

  <meta
    name="keywords"
    content="Outstation Corporate Taxi Pune, Outstation Employee Travel Pune, Pune Outstation Chauffeur Service, Corporate Intercity Cab Pune, Pune Business Trip Cab Hire, Outstation Fleet Service Pune, Pune to Mumbai Corporate Cab, Pune to Nashik Corporate Cab, Pune to Kolhapur Corporate Cab, Pune to Aurangabad Corporate Cab, Corporate Outstation Sedan Pune, Corporate Outstation SUV Pune, Corporate Outstation Tempo Traveller Pune, Executive Outstation Cab Pune, Best Outstation Cab for Corporate Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceforpuneoutstation;